const base = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

export const SearchIcon = ({ size = 14 }) => (
  <svg {...base(size)}><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
);

export const RefreshIcon = ({ size = 14 }) => (
  <svg {...base(size)}>
    <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const ArrowRightIcon = ({ size = 16 }) => (
  <svg {...base(size)}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
);

export const CheckIcon = ({ size = 14 }) => (
  <svg {...base(size)}><polyline points="20 6 9 17 4 12" /></svg>
);

export const HomeIcon = ({ size = 16 }) => (
  <svg {...base(size)}><path d="M3 9.5 12 3l9 6.5V21H3z" /><path d="M9 21v-7h6v7" /></svg>
);

export const AlertIcon = ({ size = 16 }) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><line x1="12" y1="8" x2="12" y2="13" /><line x1="12" y1="16.5" x2="12" y2="16.5" /></svg>
);

export const CloseIcon = ({ size = 14 }) => (
  <svg {...base(size)}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);

export const UndoIcon = ({ size = 14 }) => (
  <svg {...base(size)}><polyline points="9 14 4 9 9 4" /><path d="M4 9h9a7 7 0 0 1 0 14H8" /></svg>
);

export const LockIcon = ({ size = 16 }) => (
  <svg {...base(size)}><rect x="4" y="10.5" width="16" height="10" rx="2" /><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" /></svg>
);

/** Per-device-family glyphs, keyed by the room array name. */
const glyphs = {
  energiSync: (size) => (
    <svg {...base(size)}><polyline points="13 2 4 14 11 14 10 22 20 9 13 9 13 2" /></svg>
  ),
  megaControllers: (size) => (
    <svg {...base(size)}><rect x="3" y="3" width="18" height="18" rx="3" /><line x1="8" y1="8" x2="8" y2="8" /><line x1="12" y1="8" x2="12" y2="8" /><line x1="16" y1="8" x2="16" y2="8" /><line x1="7" y1="14" x2="17" y2="14" /><line x1="7" y1="17.5" x2="13" y2="17.5" /></svg>
  ),
  thermoSmarts: (size) => (
    <svg {...base(size)}><path d="M10 13.5V5a2 2 0 1 1 4 0v8.5a4 4 0 1 1-4 0z" /></svg>
  ),
  environSyncs: (size) => (
    <svg {...base(size)}><path d="M12 3s5 5.5 5 9a5 5 0 0 1-10 0c0-3.5 5-9 5-9z" /></svg>
  ),
  weatherSensors: (size) => (
    <svg {...base(size)}><circle cx="12" cy="12" r="4" /><line x1="12" y1="2" x2="12" y2="5" /><line x1="12" y1="19" x2="12" y2="22" /><line x1="2" y1="12" x2="5" y2="12" /><line x1="19" y1="12" x2="22" y2="12" /></svg>
  ),
  doorSensors: (size) => (
    <svg {...base(size)}><path d="M4 21V4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v17" /><line x1="2" y1="21" x2="20" y2="21" /><circle cx="13.5" cy="12" r="1" /></svg>
  ),
};

export const DeviceGlyph = ({ groupKey, size = 16 }) =>
  (glyphs[groupKey] || glyphs.energiSync)(size);
